// @ts-nocheck
export default {
  SET_APP_READY (state, val) {
    state.appReady = val
  },
  SET_NOTIFICATIONS_POOLING_INTERVAL (state, val) {
    state.notificationsPoolingInterval = val
  }
}
